import React, { useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import { CREATE_MEETING, ALL_MEETINGS } from "../queries";
import { TextField, Button } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import kunnat from "kunnat";
import { FormControl, Select, MenuItem } from "@mui/material";
/* eslint-disable react/prop-types */
const MeetingForm = ({ setError }) => {
  const [meetingtext, setText] = useState("");
  const [meetingdatetime, setDatetime] = useState("");
  const [organid, setOrganid] = useState("");
  const [agendaurl, setUrl] = useState("");
  const [meetingmunicipality, setMunicipality] = useState("");
  // eslint-disable-next-line
  //const [t, i18n] = useTranslation("common")
  const [t] = useTranslation("common");
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  //console.log(token);
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  //console.log(setExecuting);

  const [createMeeting] = useMutation(CREATE_MEETING, {
    refetchQueries: [{ query: ALL_MEETINGS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });

  /*
  const handleChange = (event) => {
    setNewComment(event.target.value)
  }

  const addComment = (event) => {
    event.preventDefault()
    createComment({
      content: newComment,
      important: false,
    })

    setNewComment("")
  }
  */
  const uusi = async (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    setDatetime(pvm.toString());
    setText(event);
  };

  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }

  const submit = async (event) => {
    event.preventDefault();
    createMeeting({
      variables: {
        meetingdatetime,
        meetingtext,
        agendaurl,
        meetingmunicipality,
        organid: organid.length > 0 ? organid : "tyhjä",
      },
    });
    setDatetime("");
    setText("");
    //setOrganid("");
    //setMunicipality("");
    //setUrl("");
    setSubmitted(true);
  };
  /*const stylea = {
    background: "white",
    opacity: 0.9
  }*/

  const getKunnat = (kunn) =>
    kunn.map((kunt) => {
      return (
        <MenuItem value={kunt.name} key={kunt.name}>
          {kunt.name}
        </MenuItem>
      );
    });

  if (submitted) {
    return (
      <>
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="black"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              />
              <br />
              <br />
              <MKTypography
                variant="body1"
                color="black"
                textAlign="left"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <h2>{t("headers.addmeeting")}</h2>
                {t("common.formok")}
                <br />
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  } else {
    return (
      <>
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="black"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              />
              <h2>{t("headers.addmeeting")}</h2>
              <MKTypography
                variant="body1"
                color="black"
                textAlign="left"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <form onSubmit={submit}>
                  {t("common.time")}
                  <TextField value={meetingtext} onChange={({ target }) => uusi(target.value)} />
                  <br />
                  <br />
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={meetingmunicipality}
                      label={t("common.municipality")}
                      onChange={(e) => setMunicipality(e.target.value)}
                      style={{ backgroundColor: "white" }}
                    >
                      {getKunnat(kunnat)}
                    </Select>
                  </FormControl>
                  {t("common.municipal")}
                  <TextField
                    value={meetingmunicipality}
                    onChange={({ target }) => setMunicipality(target.value)}
                  />
                  <br />
                  <br />
                  {t("common.organ")}
                  <TextField value={organid} onChange={({ target }) => setOrganid(target.value)} />
                  <br />
                  <br />
                  Url
                  <TextField value={agendaurl} onChange={({ target }) => setUrl(target.value)} />
                  <br />
                  <br />
                  <div>
                    <ReCAPTCHA
                      sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                      onChange={onChange}
                    />
                  </div>
                  <br />
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    type="submit"
                    disabled={!verified}
                    executing={executing}
                    submitted={submitted}
                  >
                    {submitted ? t("common.done") : executing ? "Verifying" : t("common.save")}
                  </Button>
                  <br />
                  <br />
                </form>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
};

export default MeetingForm;
